module.exports = __webpack_public_path__ + "media/financial_aid_videos/cloud_background-0ab325f8.png";